var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.8 32.9",
    style: {
      enableBackground: "new 0 0 32.8 32.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,3.8c-1,0-1.9,0.1-2.9,0.3c-2.6,0.4-3.1,1.4-3.1,3.2v2.3h6.1v0.8H8c-1.8,0-3.4,1.3-3.8,3.1 c-0.6,2-0.6,4.1,0,6.2c0.4,1.8,1.5,3.1,3.2,3.1h2.1v-2.8c0-2.1,1.7-3.7,3.8-3.8h6.1c1.7,0,3.1-1.4,3.1-3c0,0,0,0,0,0V7.2 c-0.1-1.7-1.4-3-3.1-3.2C18.3,3.9,17.2,3.8,16.2,3.8 M12.9,5.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2l0,0 C11.8,6.1,12.3,5.6,12.9,5.6C12.9,5.6,12.9,5.6,12.9,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,10.3V13c0,2.1-1.7,3.8-3.8,3.8h-6.1c-1.7,0-3,1.4-3.1,3.1v5.8c0,1.6,1.4,2.6,3.1,3c2,0.6,4.1,0.6,6.1,0 c1.5-0.4,3.1-1.3,3.1-3v-2.3h-6.1v-0.8h9.1c1.7,0,2.4-1.2,3-3.1c0.6-2,0.6-4.2,0-6.2c-0.4-1.8-1.2-3.1-3-3.1L23.1,10.3z  M19.8,24.9c0.6-0.1,1.2,0.4,1.3,1s-0.4,1.2-1,1.3c-0.1,0-0.1,0-0.2,0c-0.6,0-1.1-0.5-1.1-1.1C18.6,25.4,19.1,24.9,19.8,24.9 C19.7,24.9,19.8,24.9,19.8,24.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.0dc4b8efd380b6a4c4b73851a02e98f3.svg";
export { ForwardRef as ReactComponent };